import React from "react";
import Recharge from "../recharge/Recharge";

const RechargeModal = ({ show, handleClose, callApi }) => {
  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "640px",
                height: "517px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">Recharge</h5>
              </div>

              <div>
                <Recharge handleClose={handleClose} callApi={callApi} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RechargeModal;
